;(() => {
  const MENU_SELECTOR = '.collection-top-menu'
  const LINK_SELECTOR = '.collection-top-menu__link'
  const SELECT_SELECTOR = '.collection-top-menu__select'
  const GRID_CONTAINER_ID = 'ProductGridContainer'

  const isModifiedClick = (event) =>
    event.metaKey || event.ctrlKey || event.shiftKey || event.altKey

  const normalizeUrl = (url) => {
    try {
      return new URL(url, window.location.origin).href
    } catch (e) {
      return url
    }
  }

  const setActiveLink = (menuEl, activeUrl) => {
    const normalizedActiveUrl = normalizeUrl(activeUrl)
    const links = menuEl.querySelectorAll(LINK_SELECTOR)
    links.forEach((a) => {
      const isActive = normalizeUrl(a.href) === normalizedActiveUrl
      a.classList.toggle('is-active', isActive)
      if (isActive) a.setAttribute('aria-current', 'page')
      else a.removeAttribute('aria-current')
    })

    const selectEl = menuEl.querySelector(SELECT_SELECTOR)
    if (!selectEl) return

    const options = selectEl.querySelectorAll('option')
    options.forEach((option) => {
      const isActive = normalizeUrl(option.value) === normalizedActiveUrl
      option.selected = isActive
    })
  }

  const setLoading = (isLoading) => {
    const container = document.getElementById(GRID_CONTAINER_ID)
    if (!container) return
    const collectionEl = container.querySelector('.collection')
    if (!collectionEl) return
    collectionEl.classList.toggle('loading', isLoading)
  }

  const replaceGrid = (htmlText) => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(htmlText, 'text/html')
    const incoming = doc.getElementById(GRID_CONTAINER_ID)
    const current = document.getElementById(GRID_CONTAINER_ID)

    if (!incoming || !current) return false

    current.innerHTML = incoming.innerHTML

    current.querySelectorAll('.scroll-trigger').forEach((el) => {
      el.classList.add('scroll-trigger--cancel')
    })

    return true
  }

  const loadUrlIntoGrid = async (
    url,
    { updateHistory } = { updateHistory: true }
  ) => {
    setLoading(true)

    try {
      const res = await fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })

      if (!res.ok) throw new Error(`Request failed: ${res.status}`)
      const htmlText = await res.text()

      const ok = replaceGrid(htmlText)
      if (!ok) {
        window.location.href = url
        return
      }

      if (updateHistory) {
        history.pushState({ url }, '', url)
      }
    } catch (e) {
      window.location.href = url
    } finally {
      setLoading(false)
    }
  }

  const initStickySelect = (menuEl) => {
    const selectWrapper = menuEl.querySelector('.collection-top-menu__select-wrapper')
    if (!selectWrapper) return

    // 创建占位元素，fixed 定位后保持页面高度不跳变
    const placeholder = document.createElement('div')
    placeholder.className = 'collection-top-menu__placeholder'
    selectWrapper.parentNode.insertBefore(placeholder, selectWrapper)

    let ticking = false

    const updateSticky = () => {
      // nav 顶部到达或超过视口顶部 → 开启 sticky
      const shouldStick = menuEl.getBoundingClientRect().top <= 0
      menuEl.classList.toggle('is-sticky', shouldStick)
      ticking = false
    }

    // 初始化时立即检查一次（处理刷新时已在页面中部的情况）
    updateSticky()

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateSticky)
        ticking = true
      }
    }, { passive: true })
  }

  const bind = () => {
    const menuEl = document.querySelector(MENU_SELECTOR)
    if (!menuEl) return

    initStickySelect(menuEl)

    menuEl.addEventListener('click', (event) => {
      const link = event.target.closest(LINK_SELECTOR)
      if (!link) return
      if (event.button !== 0) return
      if (isModifiedClick(event)) return

      event.preventDefault()

      const url = link.href
      setActiveLink(menuEl, url)
      loadUrlIntoGrid(url, { updateHistory: true })
    })

    const selectEl = menuEl.querySelector(SELECT_SELECTOR)
    if (selectEl) {
      selectEl.addEventListener('change', () => {
        const url = selectEl.value
        if (!url) return

        setActiveLink(menuEl, url)
        loadUrlIntoGrid(url, { updateHistory: true })

        // 移动端切换后滚回顶部，方便查看新内容
        if (window.matchMedia('(max-width: 749px)').matches) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      })
    }

    window.addEventListener('popstate', (event) => {
      const url =
        event.state && event.state.url ? event.state.url : window.location.href
      setActiveLink(menuEl, url)
      loadUrlIntoGrid(url, { updateHistory: false })
    })

    setActiveLink(menuEl, window.location.href)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind)
  } else {
    bind()
  }
})()
